import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-128" data-mp="bq9f2pruf808">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-129" data-mp="195wsldarnr9y">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 text-white shadow-[0_8px_0_0_#11823B,0_16px_32px_-8px_rgba(0,0,0,0.45)] transition-colors duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-130" data-mp="2f410ecm2azqp">
            <ShoppingCartIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-131" data-mp="1rgkgnycv4dbd" />
            <span className="font-display text-[16px] font-extrabold uppercase tracking-wide sm:text-lg" data-id="element-132" data-mp="1weufcixspw1q">
              Get the Blueprint — $27
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}